import React, { useContext, useState } from "react";
import { AlertModalInput } from "./AlertModalInput";
import { save } from "./mailRecipientService";
import { TableContext } from "../index";
import { EMAIL_REGEX } from "../vars";

const initialRecipient = {
    firstName: '',
    lastName: '',
    email: ''
}

export function AddRecipientModal({ closeModal }) {
    const formId = "oct-alert-recipient-form";
    const { config, setConfig } = useContext(TableContext);
    const [recipient, setRecipient] = useState(initialRecipient);
    const isValid = () => recipient.firstName && recipient.lastName && validateEmail(recipient.email);

    const onFieldChange = (key, value) => {
        setRecipient({ ...recipient, [key]: value });
    }

    const validateEmail = (email) => {
        return EMAIL_REGEX.test(String(email).toLowerCase());
    }

    const onSubmitClick = async () => {
        if (isValid()) {
            const success = await save(recipient);
            if (success) {
                setConfig({ ...config, lastUpdated: Date.now() });
                closeModal();
            }
        }
    }

    return (
        <div className="modal oct_display-block modal-v2-root oct_alert-v2-modal oct_alert-v2-modal--recipient">
            <div className="modal fade oct_modal show modal-v2-overlay">
                <div className="modal-dialog modal-dialog-centered modal-v2-dialog oct_alert-v2-modal-dialog" aria-modal="true">
                    <div className="modal-content modal-v2-shell oct_alert-v2-modal-shell">
                        <div className="modal-v2-header oct_alert-v2-modal-header">
                            <div className="modal-v2-header-top">
                                <div className="modal-v2-header-copy">
                                    <h2 className="modal-v2-heading">Add Additional Recipient</h2>
                                    <p className="modal-v2-subheading">
                                        Create a recipient entry for email alerts and notification routing.
                                    </p>
                                </div>
                                <button type="button" className="close modal-v2-close" aria-label="Close" onClick={closeModal}>
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                        </div>

                        <div className="modal-body modal-v2-body oct_alert-v2-modal-body">
                            <form id={formId} className="oct_alert-v2-form modal-v2-form" autoComplete={"off"} onSubmit={(event) => {
                                event.preventDefault();
                                onSubmitClick();
                            }}>
                                <div className="oct_alert-v2-form-grid oct_alert-v2-form-grid--single">
                                    <AlertModalInput
                                        label={"First Name"}
                                        value={recipient.firstName}
                                        valid={recipient.firstName}
                                        onChange={(value) => onFieldChange('firstName', value)}
                                        required
                                    />
                                    <AlertModalInput
                                        label={"Last Name"}
                                        value={recipient.lastName}
                                        valid={recipient.lastName}
                                        onChange={(value) => onFieldChange('lastName', value)}
                                        required
                                    />
                                    <AlertModalInput
                                        label={"Email"}
                                        valid={validateEmail(recipient.email)}
                                        value={recipient.email}
                                        onChange={(value) => onFieldChange('email', value)}
                                        required
                                    />
                                </div>
                            </form>
                        </div>

                        <div className="modal-footer modal-v2-footer oct_alert-v2-modal-footer">
                            <div className="modal-v2-footer-note">
                                <span className="modal-v2-footer-note-star">*</span> Required fields
                            </div>
                            <div className="modal-v2-footer-actions oct_alert-v2-modal-actions">
                                <button
                                    type="button"
                                    className="btn modal-v2-btn modal-v2-btn-outline oct_alert-v2-modal-btn"
                                    onClick={closeModal}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="btn modal-v2-btn modal-v2-btn-primary oct_alert-v2-modal-btn"
                                    onClick={onSubmitClick}
                                    type="submit"
                                    form={formId}
                                    disabled={!isValid()}
                                >
                                    Create
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
